import { FC } from 'react';
import { useTranslation } from 'next-i18next';

import { newrelic } from '@phoenix/core/frontend/shared/ui/newrelic/newrelic';
import { EditorialHorizontalCard } from '@phoenix/core/frontend/shared/ui/editorial-card/editorial-horizontal-card';
import { GlobalLink } from '@phoenix/core/frontend/shared/domain/static-content/static-content.static-generation.model';
import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

import { DynamicLinkWrapper } from '@phoenix/team-m/dashboard/frontend/shared/dynamic-link-wrapper';

export const CatalogueCard: FC<{ link: GlobalLink }> = ({ link }) => {
  const { t } = useTranslation();

  const onClickLink = () => {
    newrelic.addPageAction('Dashboard', {
      context: 'interesting-for-you-section',
      triggerType: 'card',
      triggerName: link.name,
      triggerAction: 'click',
    });
  };

  return link && link.url !== '#' ? (
    <DynamicLinkWrapper onClick={onClickLink} hyperLink={link.url} allowReferrer={true}>
      <EditorialHorizontalCard
        className="mt-12 tablet:h-[14.5rem] desktop:mt-16 desktop:h-[11.5rem]"
        image={{
          src: 'machine-service-accesories.jpg',
          isPhoenix: true,
          sizes: `(max-width: ${containerQueries.tablet}) 100vw, (max-width: ${containerQueries.desktop}) 50vw, 30vw`,
          staticTags: ['imagesDashboard'],
        }}
        tag={t('dashboard_inspoShopping_card_catalogue_tag')}
        title={t('dashboard_inspoShopping_card_catalogue_headline')}
        description={t('dashboard_inspoShopping_card_catalogue_subHeadline')}
        data-testid="catalogue-link-card"
        isLinkOut={true}
        reverse
      />
    </DynamicLinkWrapper>
  ) : null;
};
